/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Campus_Callout_DescInputs */

const en_dr_campus_callout_desc = /** @type {(inputs: Dr_Campus_Callout_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before the wizard, the team and the problem-owning advisor agree on the problem, the users and the riskiest hypothesis together — in a structured room, not a proposal draft.`)
};

const id_dr_campus_callout_desc = /** @type {(inputs: Dr_Campus_Callout_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum wizard, tim dan dosen pemilik masalah menyepakati bersama apa masalahnya, siapa penggunanya, dan hipotesis mana yang paling berisiko — di ruang terstruktur, bukan draf proposal.`)
};

/**
* | output |
* | --- |
* | "Before the wizard, the team and the problem-owning advisor agree on the problem, the users and the riskiest hypothesis together — in a structured room, not a..." |
*
* @param {Dr_Campus_Callout_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_campus_callout_desc = /** @type {((inputs?: Dr_Campus_Callout_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Campus_Callout_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_campus_callout_desc(inputs)
	return en_dr_campus_callout_desc(inputs)
});